import { Image as MantineImage } from "@mantine/core";

interface ImageProps {
  alt?: string;
  src?: string;
  title?: string;
}

/**
 * Image renders an image responsively through Mantine `Image`.
 */
export const Image = ({ alt, src, title }: ImageProps) => (
  <MantineImage alt={alt} my="md" radius="sm" src={src} title={title} />
);
